import { render, staticRenderFns } from "./PurchaseOrderDetailsForm.vue?vue&type=template&id=63419926&scoped=true&"
import script from "./PurchaseOrderDetailsForm.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderDetailsForm.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseOrderDetailsForm.vue?vue&type=style&index=0&id=63419926&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63419926",
  null
  
)

export default component.exports